{
  "assets": {
    "MapIcon": "Ícone",
    "Model": "Modelo 3D",
    "none_selected_warning": "Você deve ter um {{ assetType }} selecionado",
    "all_categories": "Todas as categorias",
    "select": "Selecione {{ assetType }}",
    "search_placeholder": "Pesquisar por {{ assetType }}"
  },
  "layerTemplates": {
    "selectTemplateText": "Modelos de camada de pesquisa",
    "createCustomLayer": "Crie uma camada personalizada",
    "startFromScratch": "inicie uma nova camada do zero",
    "failedToLoadTemplates": "Falha ao carregar modelos de camada",
    "failedToLoadLayer": "Falha ao carregar a camada",
    "noLayerTemplates": "Não encontramos nenhum modelo com esse nome. Você gostaria de começar uma nova camada sem usar um modelo em vez disso?",
    "searchPlaceholder": "Por exemplo, transporte",
    "allTemplates": "Todos os modelos",
    "searchResults": "Resultados da pesquisa"
  },
  "toolbarButtonTooltips": {
    "draw_map_object": "Desenhar",
    "undo": "Desfazer",
    "redo": "Refazer",
    "copy_map_objects": "Copiar/colar",
    "draw_analysis_line": "Desenhe uma linha",
    "draw_analysis_polygon": "Desenhar polígono",
    "draw_rectangle": "Desenhe um retângulo",
    "draw_point": "Ponto de desenho",
    "draw_icon": "Ícone de desenho",
    "draw_model": "Desenhe o modelo",
    "draw_line_model": "Modelo de linha de desenho",
    "snapping_tools": "Configurações de encaixe"
  },
  "sidebarButtonTooltips": {
    "new_layer": "Criar camada a partir do modelo",
    "import_layer": "Importar camada (s) de outros planos",
    "attribute_data_table": "Tabela de dados de atributos",
    "toggle_all_layers_visibility": "Alternar a visibilidade de todas as camadas",
    "hide_all_layers": "Ocultar todas as camadas",
    "show_all_layers": "Mostrar todas as camadas",
    "change_log": "Registro de alterações"
  },
  "toggleAllLayersVisibilityConfirmation": {
    "title": "Alternar a visibilidade de todas as camadas",
    "message": "Isso mudará a visibilidade de todas as camadas para todos os usuários. Tem certeza de que deseja continuar?"
  },
  "layerOptionsTooltips": {
    "layer_information": "Informações da camada",
    "layer_view_options": "Opções de visualização em camadas",
    "hide_layer": "Ocultar camada",
    "show_layer": "Mostrar camada"
  },
  "backgroundMapSelector": {
    "background_map_options": "Opções de plano de fundo",
    "recommended": "Recomendado",
    "configure": "Configurar"
  },
  "sitemaps": {
    "no_sitemaps_available": "Não há mapas do site neste local.\nOs sitemaps são mapas detalhados de locais, como desenhos CAD que mostram o layout interno de um edifício.",
    "no_sitemaps_available_2": "\npara saber mais sobre como adicionar sitemaps"
  },
  "drawing_tooltips": {
    "title": "Ferramentas de desenho",
    "enter_edit_mode": "Clique aqui e, em seguida, clique no mapa para começar a desenhar",
    "enter_edit_mode_no_layers": "Para começar a desenhar no mapa, primeiro crie (ou selecione) uma camada usando o painel à esquerda",
    "enter_composition_part_1": "Clique no mapa para adicionar pontos. Clique duas vezes ou pressione",
    "enter_composition_part_2": "para terminar."
  },
  "search_tooltip": {
    "set_save_title": "Definir esse local como padrão para o plano?",
    "set_save_content": "O plano retornará a esse local na próxima vez que você o abrir.",
    "set_save_save": "Salvar visualização",
    "set_save_dismiss": "Talvez mais tarde",
    "save_info_title": "Visualizações salvas",
    "save_info_content": "Você pode gerenciar as visualizações salvas do plano ou alterar o padrão do seu plano no menu de pesquisa.",
    "save_info_got_it": "Entendi"
  },
  "attributes": {
    "allowed_metadata_properties": "Propriedades de metadados permitidas",
    "required": "Obrigatório",
    "system_datafield_type": "Tipo de campo de dados do sistema"
  },
  "map_tour": {
    "tip_3_location": {
      "title": "Encontre um local",
      "content": "Aqui, você pode pesquisar lugares no plano, como ruas, lugares ou objetos que você colocou. Você também pode salvar locais importantes para acessar e definir um padrão para seu plano."
    },
    "tip_4_background": {
      "title": "Escolha o plano de fundo do seu mapa",
      "content": "Aqui, você pode escolher entre diferentes planos de fundo de mapas, como imagens de satélite ou provedores de mapeamento locais. Você também pode definir o plano de fundo padrão."
    },
    "tip_5_layer": {
      "title": "Crie sua primeira camada",
      "content": "Para começar a desenhar, crie uma nova camada."
    }
  },
  "zoomableValues": {
    "fixed": "Fixo",
    "by_zoom_level": "Por nível de zoom",
    "edit_zoom_levels": "Editar níveis de zoom",
    "predefined": "Predefinido",
    "custom": "Personalizado",
    "hide": "Esconder",
    "add_zoom_level": "Adicionar novo nível de zoom",
    "zoom_options": "Opções de zoom",
    "zoom_levels": "Níveis de zoom",
    "street_level": "No nível da rua",
    "city_level": "No nível da cidade",
    "country_level": "Em nível de país",
    "world_level": "A nível mundial",
    "max_level": "No nível máximo de zoom"
  },
  "sidebarToolbar": {
    "share": "Plano de compartilhamento"
  },
  "units": {
    "pixels": "Pixels",
    "degrees": "Diplomas",
    "scale": "Escala",
    "meters": "Metros"
  }
}